import React from 'react';
import PropTypes from 'prop-types';
import { Panel } from 'react-bootstrap';
import ActivityGroup from './ActivityGroup.jsx';

export default class FeedList extends React.Component {
	// WARNING: Check this function if the component is not updating when you need it to
	shouldComponentUpdate(nextProps, nextState) {
		return this.props.isBulkActive !== nextProps.isBulkActive ||
			JSON.stringify(this.props.bulkActivities) !== JSON.stringify(nextProps.bulkActivities) ||
			JSON.stringify(this.props.filteredActivitiesMap) !== JSON.stringify(nextProps.filteredActivitiesMap) ||
			JSON.stringify(this.props.filteredActivities) !== JSON.stringify(nextProps.filteredActivities);
	}

	render() {
		const { filteredActivities, filteredActivitiesMap, datasetInfo } = this.props;
		const activityIds = [];
		if (!filteredActivities || !datasetInfo) {
			return (<div>Please select a project to view the Feed List</div>);
		}

		// Sort activities by last updated
		filteredActivities.sort(function(a, b) {
			return a.updateDate > b.updateDate ? -1 : 1;
		});

		for (let i = 0; i < filteredActivities.length; i++) {
			const activity = filteredActivities[i];
			if (activity.taskType !== 'TT_LOE') {
				activityIds.push(activity.activityId);
			}
		}

		const activitiesForFeed = activityIds.filter(activityId => {
			return activityId in filteredActivitiesMap && filteredActivitiesMap[activityId] in filteredActivities;
		}).map(activityId => {
			return filteredActivities[filteredActivitiesMap[activityId]];
		});

		if (!activitiesForFeed.length) {
			return (<div>No activities match your filters.</div>);
		}

		return (
			<Panel
				defaultExpanded
				className="groupTreePanel">
				<Panel.Heading>
					<Panel.Title toggle>{`Recent Feed (${activitiesForFeed.length})`}</Panel.Title>
				</Panel.Heading>
				<Panel.Collapse>
					<ActivityGroup
						className="groupTreeActivityGroup"
						activities={activitiesForFeed}
						datasetInfo={datasetInfo} />
				</Panel.Collapse>
			</Panel>
		);
	}
}

FeedList.propTypes = {
	filteredActivities: PropTypes.array,
	filteredActivitiesMap: PropTypes.object,
	datasetInfo: PropTypes.object,
	isBulkActive: PropTypes.bool,
	bulkActivities: PropTypes.array
};